import React, {MouseEvent, useCallback, useRef, useState} from 'react';
import cx from 'classnames';
import {
    Icon,
    PopoverPlacement,
    PriorityIcon,
    Separator,
    Title
} from '@priority-software/priority-style-react';
import {helpPopoverRef} from '../../../../_shared/Help/constants';
import {ModernTooltip} from '../../../../components/Common/Tooltip/ModernTooltip';
import texts from '../../../ReportGenerator/texts';
import styles from './styles.module.scss';
import {ANALYTICS_REPORT_DIALOG} from '../../constants';

type Props = {
    mainTitle: string;
    helpText?: string;
    showSeparator?: boolean;
    componentClasses?: string;
};

export const ReportsToolbarContent = (props: Props) => {
    const {mainTitle, helpText, showSeparator = true, componentClasses} = props;
    const wrapRef = useRef(null);
    const [tooltipEvents, setTooltipEvents] = useState(true);

    const showHelp = useCallback(
        (e: MouseEvent<HTMLElement>) => {
            setTooltipEvents(false);

            helpPopoverRef.current.showHelpPopover({
                title: texts.help_popover_title,
                content: helpText,
                anchor: e.currentTarget,
                portalSelector: wrapRef.current,
                onClose: () => {
                    setTooltipEvents(true);
                },
                placement: PopoverPlacement.leftStart
            });
        },
        [helpText, setTooltipEvents]
    );

    return (
        <div className={cx(styles.toolbarTop, componentClasses)} ref={wrapRef}>
            <div className={styles.toolbarTopLeftPart}>
                <Title
                    skin="h4"
                    textColor="primary-700"
                    text={texts.chooseReportsMenuTitle}
                    componentClasses={styles.fixedText}
                />
                &nbsp;
                <ModernTooltip
                    tooltip={mainTitle}
                    maxWidth={800}
                    arrowOffset={8}
                    position="top"
                    tooltipOffset={8}
                    portalId={ANALYTICS_REPORT_DIALOG}
                >
                    <Title
                        skin="h4"
                        textColor="secondary-500"
                        componentClasses={cx(styles.subTitle, styles.ellipsis)}
                    >
                        {mainTitle}
                    </Title>
                </ModernTooltip>
            </div>

            <div className={styles.toolbarTopRightPart}>
                <ModernTooltip
                    tooltip={texts.analyticsHelpTooltip}
                    maxWidth={400}
                    arrowOffset={8}
                    position="left-start"
                    tooltipOffset={8}
                    portalId={ANALYTICS_REPORT_DIALOG}
                    wrapperClassname={cx({
                        [styles.pointerNone]: !tooltipEvents
                    })}
                >
                    <Icon
                        onClick={showHelp}
                        icon={PriorityIcon.questionCircle}
                        iconColor="secondary-500"
                    />
                </ModernTooltip>

                {showSeparator && <Separator componentClasses={styles.separator} height={30} />}
            </div>
        </div>
    );
};
